module.exports = __webpack_public_path__ + "static/media/bagy13.0103ff3f.png";